<template>
  <div class="main">
    <div class="select" v-click-outside="handleHide">
      <div class="selected-value" @click="handleToggle">
        <div class="item">
          <img :src="selectedType.icon" :alt="selectedType.id" />
          <span>{{ selectedType.name }}</span>
        </div>
        <!-- <div class="arrow"> -->
        <div class="arrow d-none">
          <img
            v-if="!isOpen"
            src="/images/professionals/icons/arrow-down.svg"
            alt=""
          />
          <img v-else src="/images/professionals/icons/arrow-up.svg" alt="" />
        </div>
      </div>
      <ul v-if="isOpen">
        <li
          v-for="item in this.types.filter((type) => type !== selectedType)"
          :key="item.id"
        >
          <div class="item" @click="handleSelectType(item)">
            <img :src="item.icon" alt="" />
            <span>{{ item.name }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="profile">
      <div class="row flex-nowrap">
        <div class="col pr-2 flex-fill d-flex align-items-center">
          <img :src="(me.avatar) ? '/' + me.avatar : '/images/avatar.jpg' " alt="" />
        </div>
        <div class="col-6 px-2">
          <span>Nome da conta</span><br>
          <span>{{ network.youtube }}</span>
        </div>
        <div class="col flex-fill pl-2 text-right">
          <span>Seguidores</span><br>
          <span>{{ network.youtube_subscribers }}</span>
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import ClickOutside from "vue-click-outside";

export default {
  props: [
    'me', 'network',
  ],
  directives: {
    ClickOutside,
  },
  data() {
    return {
      isOpen: false,
      types: [
        // {
        //   id: "instagram",
        //   name: "Instagram",
        //   icon: "/images/professionals/instagram.svg",
        // },
        {
          id: "youtube",
          name: "Youtube",
          icon: "/images/professionals/youtube.svg",
        },
        // {
        //   id: "twitter",
        //   name: "Twitter",
        //   icon: "/images/professionals/twitter.svg",
        // },
      ],
      selectedType: [],
    };
  },
  methods: {
    handleToggle: function () {
      this.isOpen = !this.isOpen;
    },
    handleHide: function () {
      this.isOpen = false;
    },
    handleSelectType: function (type) {
      this.selectedType = type;
      this.isOpen = false;
    },
  },
  mounted() {
    this.selectedType = this.types[0];
  },
};
</script>

<style scoped lang="scss">
.main {
  width: 100%;
  background: #ffffff;
  border-radius: 16px;

  .select {
    cursor: pointer;
    border-bottom: 1px solid #f0f1f3;
    position: relative;

    .selected-value {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .arrow {
        right: 30px;
        position: absolute;
      }
    }

    .item {
      width: 100%;
      display: flex;
      align-items: center;
      padding: 16px 30px;

      img {
        margin-right: 12px;
      }

      span {
        font-family: SF Pro Display;
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;
        color: #000000;
      }
    }

    ul {
      width: 100%;
      background: #fff;
      position: absolute;
      border-radius: 0 0 16px 16px;
      margin: 0;
      padding: 0;
      li {
        list-style: none;
      }
    }
  }

  .profile {
    padding: 22px 27px;

    img {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }

    & > div {

      span {
        &:first-child {
          font-family: SF Pro Display;
          font-weight: bold;
          font-size: 13px;
          line-height: 16px;
          color: #a1a4b1;
          margin-bottom: 4px;
        }

        &:last-child {
          font-family: SF Pro Display;
          font-weight: bold;
          font-size: 18px;
          color: #000000;
        }
      }
    }
  }
}
</style>
